// extracted by mini-css-extract-plugin
module.exports = {"linkStyle":"style-module--link-style--2ytpv"};